import { AdminDetalleModal } from './AdminDetalleModal';
import { DetalleActividadPage } from '../../pages/DetalleActividadPage';

interface AdminDetalleActividadModalProps {
  readonly isOpen: boolean;
  readonly actividadId: string;
  readonly lumisialId: string;
  readonly lumisialNombre: string;
  readonly lumisialCiudad: string;
  readonly diocesisNombre: string;
  readonly provinciaNombre: string;
  readonly onClose: () => void;
}

export function AdminDetalleActividadModal({
  isOpen,
  actividadId,
  lumisialId,
  lumisialNombre,
  lumisialCiudad,
  diocesisNombre,
  provinciaNombre,
  onClose,
}: AdminDetalleActividadModalProps) {
  return (
    <AdminDetalleModal
      isOpen={isOpen}
      lumisialNombre={lumisialNombre}
      lumisialCiudad={lumisialCiudad}
      diocesisNombre={diocesisNombre}
      provinciaNombre={provinciaNombre}
      onClose={onClose}
    >
      <DetalleActividadPage
        actividadId={actividadId}
        lumisialIdOverride={lumisialId}
        readOnly={true}
        onBack={onClose}
      />
    </AdminDetalleModal>
  );
}
